<template>
  <div class="overflow-hidden bg-white shadow sm:rounded-lg">
    <section>
      <div class="px-4 py-5 sm:px-6 border-t border-gray-200 ">
        <h3 class="text-lg font-medium leading-6 text-gray-900">
          Beschreibung der Methode
        </h3>
        <p class="mt-1 max-w-2xl text-sm text-gray-500">
          Inhaltliche Beschreibung dieser Methode
        </p>
      </div>
      <div v-if="success" class="border-t border-gray-200 px-4 py-5 sm:p-0">
        <Markdown :content="resource.description" />
      </div>
      <div v-if="failure" class="border-t border-gray-200 px-4 py-5 sm:p-0">
        <div class="px-4 py-5 sm:px-6">
          <p class="mt-1 max-w-2xl text-sm text-gray-500">
            Für diese Methode wurde noch keine Beschreibung verfasst.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useRetrieveResource } from '@/client/actions';

const props = defineProps({practice: Object});

const parent = computed(() => props.practice.id);
const target = computed(() => '/api/practices/' + parent.value + '/content');

const { retrieve, retrieving, resource, success, failure } = useRetrieveResource(target);

const onMount = onMounted(() => retrieve());
</script>
